// UIContext.js
import React, { createContext, useState } from 'react';

export const UIContext = createContext();

export function UIProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  function openAuthDrawer(message) {
    setDrawerOpen(true);
  }

  return (
    <UIContext.Provider value={{ drawerOpen, setDrawerOpen, openAuthDrawer }}>
      {children}
    </UIContext.Provider>
  );
}
